import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from '../../assets/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { onboardingStatusAPI } from '../../store/features/checkOnboardingStatus';
import Navbar from '../../components/common/Navbar';
import MainBoardingScreen from './Main';
import Customer from './Customer';
import Leads from './Leads';
import ProcessComplete from './ProcessComplete';

const RegistrationStateSlides = [0, 1, 2, 3, 4];

function OnBoarding() {
  const [selectOnBoarding, setSelectOnBoarding] = useState(
    RegistrationStateSlides[0],
  );
  const [boardingName, setBoardingName] = useState('');
  const [boardingPhone, setPhoneBoarding] = useState('');
  const [boardingTimezone, setBoardingTimezone] = useState('UTC');
  const [boardingLanguage, setBoardingLanguage] = useState('en');
  const [logoUpload, setLogoUpload] = useState(null);
  const [customerCompanyWebsite, setCustomerCompanyWebsite] = useState('');
  const [customerAssignRole, setCustomerAssignRole] = useState('');
  const [leadContainer, setLeadContainer] = useState('');
  const [leadJobTilte, setLeadJobTitle] = useState('');
  const [emailBoarding, setEmailBoarding] = useState('');
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = useSelector((state) => state.loginToken);
  const authToken = useSelector((state) => state.loginToken);

  const renderOnboardingStep = () => {
    switch (selectOnBoarding) {
    case 0:
      return (
        <MainBoardingScreen
          boardingName={boardingName}
          boardingPhone={boardingPhone}
          boardingTimezone={boardingTimezone}
          boardingLanguage={boardingLanguage}
          setSelectOnBoarding={setSelectOnBoarding}
          setBoardingName={setBoardingName}
          setPhoneBoarding={setPhoneBoarding}
          setBoardingTimezone={setBoardingTimezone}
          setBoardingLanguage={setBoardingLanguage}
        />
      );
    case 1:
      return (
        <Customer
          setSelectOnBoarding={setSelectOnBoarding}
          setLogoUpload={setLogoUpload}
          logoUpload={logoUpload}
          customerCompanyWebsite={customerCompanyWebsite}
          setCustomerCompanyWebsite={setCustomerCompanyWebsite}
          setCustomerAssignRole={setCustomerAssignRole}
          customerAssignRole={customerAssignRole}
        />
      );
    case 2:
      return (
        <Leads
          setSelectOnBoarding={setSelectOnBoarding}
          setLeadContainer={setLeadContainer}
          leadContainer={leadContainer}
          setLeadJobTitle={setLeadJobTitle}
          setEmailBoarding={setEmailBoarding}
          emailBoarding={emailBoarding}
        />
      );
    case 3:
      return (
        <ProcessComplete
          boardingName={boardingName}
          boardingPhone={boardingPhone}
          boardingTimezone={boardingTimezone}
          boardingLanguage={boardingLanguage}
          customerCompanyWebsite={customerCompanyWebsite}
          customerAssignRole={customerAssignRole}
          leadContainer={leadContainer}
          leadJobTilte={leadJobTilte}
          emailBoarding={emailBoarding}
          logoUpload={logoUpload}
          setSelectOnBoarding={setSelectOnBoarding}
        />
      );
    default:
      return null;
    }
  };

  useEffect(() => {
    const onboardingStatusDispatcher = dispatch(
      onboardingStatusAPI({
        requestHeaders: userData?.response?.user?._id,
      }),
    );

    onboardingStatusDispatcher
      .then((response) => {
        if (response?.payload?.onboarded === true) {
          navigate('/dashboard', { replace: true });
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error('Error fetching onboarding status:', error);
        setLoading(false);
      });
  }, [userData.response?.user?._id, navigate, dispatch, authToken.response.token]);

  return (
    <div className="main-onboarding-container">
      <Navbar />
      {loading ? <Loader /> : renderOnboardingStep()}
    </div>
  );
}

export default OnBoarding;
